// Auth
export const loginPath = '/login'
export const forgotPasswordPath = '/forgot-password'
export const resetPasswordPath = '/reset-password'

// Insurance
export const insurerManagementPath = '/insurer-management'
export const addInsurerPath = '/insurer-management/add'
export const editInsurerPath = (insurerId: string) => `/insurer-management/edit/${insurerId}`
export const planManagementPath = '/plan-management'
export const addInsurancePlanPath = '/plan-management/add'
export const editInsurancePlanPath = (planId: string) => `/plan-management/edit/${planId}`

// Customer
export const customerPath = '/customer'
export const addCustomerPath = '/customer/add'
export const editCustomerPath = (customerId: string) => `/customer/edit/${customerId}`
export const customerPurchaseDetailPath = (customerId: string, transactionId: string) =>
  `/customer/edit/${customerId}/${transactionId}`

// Dealer Master
export const dealerMasterPath = '/dealer-master'
export const addDealerMasterPath = '/dealer-master/add'
export const editDealerMasterPath = (dealerId: string) => `/dealer-master/edit/${dealerId}`
export const dealerMasterPurchaseDetailPath = (dealerId: string, transactionId: string) =>
  `/dealer-master/edit/${dealerId}/${transactionId}`
//Commission
export const commissionPath = '/commission'
export const commissionDetailPath = (dealerId: string) => `/commission/detail/${dealerId}`

//User
export const userPath = '/user'
export const addUserPath = '/user/add'
export const editUserPath = (userId: string) => `/user/edit/${userId}`
export const rolePath = '/role'
export const addRolePath = '/role/add'
export const editRolePath = (roleId: string) => `/role/edit/${roleId}`

//Content
export const bannerPath = '/content/banner'
export const bannerDetailPath = (bannerId: string) => `/content/banner/detail/${bannerId}`
export const popupPath = '/content/pop-up'
export const pageContentPath = '/content/page'
export const editPageContentPath = (pageId: string) => `/content/page/${pageId}`
export const productPath = '/content/product'
export const benefitPath = '/content/benefit'
export const faqPath = '/content/faq'

//Transaction
export const transactionPath = '/transaction'
export const incompletedTransactionPath = '/incompleted-transaction'
export const completedTransactionPath = '/completed-transaction'
export const addTransactionPath = '/transaction/add'
export const transactionDetailPath = (transactionId: string) => `/transaction/detail/${transactionId}`

//Promotion
export const promotionPath = '/promotion'
export const addPromotionPath = '/promotion/add'
export const editPromotionPath = (promotionId: string) => `/promotion/edit/${promotionId}`
